import md5 from 'js-md5';
import { getPinnedParticipant } from '../../features/base/participants/functions';
import { getCurrentConference } from '../base/conference/functions';
import { getRemoteParticipants, isLocalParticipantModerator } from '../base/participants/functions';
import { appendURLParam } from '../base/util/uri';
import { getCurrentRoomId, isInBreakoutRoom } from '../breakout-rooms/functions';
import { WHITEBOARD_ID } from './constants';
const getWhiteboardState = (state) => state['features/whiteboard'];
/**
 * Indicates whether the whiteboard is enabled in the config.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {boolean}
 */
export const isWhiteboardEnabled = (state) => {
    var _a, _b, _c, _d;
    return ((_a = state['features/base/config'].whiteboard) === null || _a === void 0 ? void 0 : _a.enabled)
        && ((_b = state['features/base/config'].whiteboard) === null || _b === void 0 ? void 0 : _b.collabServerBaseUrl)
        && ((_d = (_c = getCurrentConference(state)) === null || _c === void 0 ? void 0 : _c.getMetadataHandler()) === null || _d === void 0 ? void 0 : _d.isSupported());
};
/**
 * Indicates whether the whiteboard is open.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {boolean}
 */
export const isWhiteboardOpen = (state) => getWhiteboardState(state).isOpen;
/**
 * Indicates whether the whiteboard button is visible.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {boolean}
 */
export const isWhiteboardButtonVisible = (state) => isWhiteboardEnabled(state) && (isLocalParticipantModerator(state) || isWhiteboardOpen(state));
/**
 * Indicates whether the whiteboard is present as a meeting participant.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {boolean}
 */
export const isWhiteboardPresent = (state) => getRemoteParticipants(state).has(WHITEBOARD_ID);
/**
 * Returns the whiteboard collaboration details.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {{ roomId: string, roomKey: string}|undefined}
 */
export const getCollabDetails = (state) => getWhiteboardState(state).collabDetails;
/**
 * Returns the whiteboard collaboration server url.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {string}
 */
export const getCollabServerUrl = (state) => {
    var _a;
    const collabServerBaseUrl = (_a = state['features/base/config'].whiteboard) === null || _a === void 0 ? void 0 : _a.collabServerBaseUrl;
    if (!collabServerBaseUrl) {
        return;
    }
    const { locationURL } = state['features/base/connection'];
    const inBreakoutRoom = isInBreakoutRoom(state);
    const roomId = getCurrentRoomId(state);
    const room = md5.hex(`${locationURL === null || locationURL === void 0 ? void 0 : locationURL.href}${inBreakoutRoom ? `|${roomId}` : ''}`);
    return appendURLParam(collabServerBaseUrl, 'room', room);
};
/**
 * Whether the whiteboard is visible on stage.
 *
 * @param {IReduxState} state - The state from the Redux store.
 * @returns {boolean}
 */
export const isWhiteboardVisible = (state) => {
    var _a;
    return ((_a = getPinnedParticipant(state)) === null || _a === void 0 ? void 0 : _a.id) === WHITEBOARD_ID
        || state['features/large-video'].participantId === WHITEBOARD_ID;
};
